.content {
  & img {
    overflow: hidden;
    border-radius: 12px;
  }
}

.previewImage {
  object-fit: cover;
  object-position: top center;
  height: 100%;
  width: 100%;
  position: absolute;
  filter: brightness(60%) saturate(110%);
}
